import { LOCALES } from '../common/common.constants';
import { LanguageType } from 'common/common.types';

export default (language: LanguageType): Locale =>
  language ? LOCALES[language.value] : LOCALES.default;
